export default {
  toasts: {
    load_error: 'Palkkioiden lataaminen epäonnistui',
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
    changes_got_saved: 'Muutokset tallennettu',
  },
  buttons: {
    edit: 'Muokkaa',
    cancel: 'Peruuta',
    save: 'Tallenna',
  },
  rates: {
    title: 'Käsittelymarginaali',
    description:
      'Prosentti %-muodossa sekä valinnainen kiinteä ja vähimmäismäärä veloitusta kohden. ”Mikä tahansa maksutapa” on voimassa, kun maksutapakohtaista hintaa ei ole.',
  },
};
